import {
  Button,
  DropdownMenuTrigger,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { MoreVerticalIcon } from 'lucide-react';

export interface RowActionsTriggerProps {
  /** The trigger's accessible name and its tooltip. */
  label: string;
}

/** The kebab that opens a table row's actions menu; render it inside the row's `DropdownMenu`. */
export const RowActionsTrigger = ({ label }: RowActionsTriggerProps) => (
  <TooltipProvider delayDuration={300}>
    <Tooltip>
      {/* Menu trigger outermost: the menu's `data-state` must win, as in `FolderMenu`. */}
      <DropdownMenuTrigger asChild>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="mini"
            aria-label={label}
            className="size-9 p-0"
          >
            <MoreVerticalIcon className="size-4" />
          </Button>
        </TooltipTrigger>
      </DropdownMenuTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
RowActionsTrigger.displayName = 'RowActionsTrigger';
